<app-modal #errorModal>
  <div class="modal-content">
    <div class="modal-header border-0">
      <h5 class="modal-title">{{ title }}</h5>
    </div>
    <div class="modal-body">
      {{ message }}
    </div>
    <div class="modal-footer text-center border-0 rounded-bottom">
      <button type="button" class="btn btn-primary" (click)="logOut()">{{ 'BUTTON.LOG_OUT' | translate }}</button>
    </div>
  </div>
</app-modal>